import React, {useState} from 'react';
import CustomDatePickerV2 from '../../../../../../views/pages/manage/common/commonComponents/CustomDatePicker-V2';
import AButton from '../../../../../../views/pages/manage/common/form-fields-mui/AButton';

const FilterForm = ({
    receiptsFilterForm,
    setReceiptsFilterForm,
    closePopup
}) => {

    const [localForm, setLocalForm] = useState(receiptsFilterForm);
    const formHandler = (key, val) => setLocalForm(prev => ({...prev, [key] : val}));

    return (
        <div className='d-flex flex-column p-3' style={{width : '250px'}}>

            <h3 className='mb-0'>Filter By</h3>
            <div>
                <CustomDatePickerV2
                    // key={formKey}
                    label={"Receipt Date"}
                    value={localForm?.fromDate}
                    handler={(index, date) => {
                        formHandler("fromDate", date);
                        formHandler("toDate", new Date());
                        // onChange(date);
                    }}
                    placeHolder={"From"}
                // minDate={minDate}
                maxDate={new Date()}
                // disabled={disabled}
                />
            </div>
            <div>
                <CustomDatePickerV2
                    // key={formKey}
                    label={"Receipt Date"}
                    value={localForm?.toDate}
                    handler={(index, date) => {
                        formHandler("toDate", date);
                        // onChange(date);
                    }}
                    placeHolder={"To"}
                    minDate={localForm?.fromDate}
                maxDate={new Date()}
                // disabled={disabled}
                />

            </div>
                <AButton
                    variant='primary_filled'
                    size='xs'
                    className='no-ml-btn mt-2'
                    disabled={(!localForm?.fromDate || !localForm?.toDate)}
                    onClick={() => {
                        setReceiptsFilterForm(prev => ({...prev, ...localForm }));
                        closePopup();
                    }}
                >
                    Apply
                </AButton>

                <AButton
                    variant='outline_danger'
                    size='xs'
                    className='no-ml-btn mt-2'
                    disabled={(!receiptsFilterForm?.toDate && !receiptsFilterForm?.fromDate)}
                    onClick={() => {
                        const emptyLocalForm = {fromDate : "", toDate : ""}
                        setLocalForm(emptyLocalForm);
                        setReceiptsFilterForm(prev => ({...prev, ...emptyLocalForm}));
                        closePopup();
                    }}
                >
                    Reset
                </AButton>
        </div>
    );
}

export default FilterForm;